export default class TcpaShieldService {
  /** @ngInject **/
  constructor(
    $http,
    ngAuthSettings
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
  }


  getSecureUrl(accountId) {
    var url = this.#serviceBaseUrl(accountId) +'/secure-urls';
    return this.$http.get(url).then(function (response) {
      return response.data;
    });
  }

  getUrls(accountId) {
    var url = this.#serviceBaseUrl(accountId) + '/urls';
    return this.$http.get(url).then(function (response) {
      return response.data;
    });
  }

  uploadFile(accountId, file) {
    var url = this.#serviceBaseUrl(accountId) + '/process-file';

    var fd = new FormData();
    fd.append(file.name, file);

    return this.$http.post(url, fd, {
      headers: { 'Content-Type': undefined }
    }).then(function (data) {
      // https://stackoverflow.com/questions/14215049/how-to-download-file-using-angularjs-and-calling-mvc-api
      var fileContent = new Blob([data.data], {
        type: data.headers('Content-Type')
      });
      //trick to download store a file having its URL
      var fileURL = URL.createObjectURL(fileContent);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = file.name;
      document.body.appendChild(a); //create the link "a"
      a.click(); //click the link "a"
      document.body.removeChild(a); //remove the link "a"
    });
  }

  getHistory(accountId) {
    var url = this.#serviceBaseUrl(accountId) + '/history';
    return this.$http.get(url).then(function (response) {
      return response.data;
    });
  }

 #serviceBaseUrl(accountId) {
    return this.serviceBaseUri + accountId + '/TCPAShield';
  }
}
